<template>
  <div class="row_center_center coupon" @click="toPage(item.coupon_uuid
  )">
    <div class="column_center_between coupon_image">
      <img src="@/assets/coupon_img.png" />
      <input type="button" value="使用" class="claim_button" style="background-color: #FD5001; color: #fff;" @click="useCoupon(item.coupon_uuid
  )" />
    </div>
    <div class="coupon_detail">
      <div class="column_start_start">
        <text class="coupon_title text_two_lines">{{ item.title }}</text>
        <text class="coupon_descrption text_three_lines">{{ item.description }}</text>
      </div>
      <text class="usage_duration text_one_line">
        使用期限：{{ item.usage_period_begin }} ~ {{ item.usage_period_end }}
      </text>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {};
  },
  mounted() { },
  methods: {
    useCoupon(id) {
      event.stopPropagation();
      this.$emit("useCoupon", id);
    },
    toPage(id) {
      this.$emit("toPage", id);
    },
  },
};
</script>
<style lang="scss" scoped></style>
